import { take } from 'lodash';
import filters from './filters';

export const listFilters = (query, options = {}) => {
  const delimiter = options.delimiter == null ? ' • ' : options.delimiter;

  let labels = [];

  filters.forEach((filter) => {
    labels = labels.concat(filter.getLabels(query));
  });

  if (options.limit) {
    labels = take(labels, options.limit);
  }

  return labels.join(delimiter || '');
};